import React from 'react'
import { useHistory } from 'react-router-dom'
import { DateObject } from 'react-multi-date-picker'
import { CircularProgress, makeStyles, Popover } from '@material-ui/core'
import { extractMonth } from '../../utils/extractDate'
import CalendarComponent from '../calendar/Calendar'

const useStyles = makeStyles(theme => ({
  root: {
    height: props => props.heigh || 300,
    width: props => props.width || 310,
    '& .rmdp-day.rmdp-selected span:not(.highlight)': {
      color: 'unset !important'
    },
    '& span:hover': { color: 'unset !important' },
    '& .rmdp-calendar': { borderRadius: 16, backgroundColor: '#F5F6F7' },
    '& .rmdp-wrapper': { width: '100%' },
    '& .rmdp-shadow': { boxShadow: 'none' },
    '& .rmdp-header-values span': { fontSize: '20px', color: '#386093' },
    '& .rmdp-day.rmdp-today span': {
      border: '1px solid #386093',
      backgroundColor: 'transparent',
      color: 'black'
    },
    '& .rmdp-week-day': { color: 'black' },
    '& .rmdp-week': { width: '300px' }
  },
  calendar_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 12
  },
  subtitle_wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: 4
  },
  dot: {
    width: 14,
    height: 14,
    backgroundColor: '#A2CC79',
    borderRadius: 50
  },
  subtitle: {
    margin: 0,
    fontSize: 12,
    fontWeight: 500,
    color: '#7B7B7B'
  },
  popover: {
    padding: 12
  },
  reports_wrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& .selectable_option': {
      cursor: 'pointer'
    }
  }
}))

export default function ReportCalendar ({
  width,
  heigh,
  getReportStudents,
  childId,
  reportStudents,
  cleanReportStudents
}) {
  const classes = useStyles({ width, heigh })
  const history = useHistory()
  const [viewDate, setViewDate] = React.useState(() => new DateObject())
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [reportsForDay, setReportsForDay] = React.useState([])

  // Converte reports -> Set de timestamps para destacar dias
  const highlightedDays = React.useMemo(
    () => {
      const items = reportStudents?.items || []
      return new Set(
        items.map(item => {
          const d = new Date(item?.report?.created_at)
          d.setHours(0, 0, 0, 0)
          return d.getTime()
        })
      )
    },
    [reportStudents?.items]
  )

  const fetchByMonth = React.useCallback(
    dateObj => {
      const { beginningOfMonth, endOfMonth } = extractMonth(dateObj)
      getReportStudents({
        params: {
          'q[child_id_eq]': childId,
          'q[created_at_gteq]': beginningOfMonth,
          'q[created_at_lteq]': endOfMonth,
          'q[status_eq]': 2
        },
        getAll: true
      })
    },
    [childId]
  )

  React.useEffect(() => {
    if (reportStudents?.items?.length === 0) {
      fetchByMonth(viewDate)
    }
    return () => cleanReportStudents()
  }, [])

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickReport = rpStudent => {
    const reportId = rpStudent.report.id
    const reportStudentId = rpStudent.id
    history.push(`/reports/${reportId}/classroom/${reportStudentId}`)
  }

  const handleAnchorEl = (currentTarget, currentDate) => {
    const reportsDay = reportStudents?.items?.filter(r => {
      const reportTs = new Date(r.report.created_at).setHours(0, 0, 0, 0)
      return reportTs === currentDate.setHours(0, 0, 0, 0)
    })
    if (reportsDay.length > 1) {
      setAnchorEl(currentTarget)
      setReportsForDay(reportsDay)
    } else if (reportsDay.length === 1) {
      handleClickReport(reportsDay[0])
    }
  }
  const handleViewChange = next => {
    setViewDate(next)
    fetchByMonth(next)
  }

  if (reportStudents?.isFetching) return <CircularProgress />
  return (
    <div className={classes.root}>
      <div className={classes.calendar_wrapper}>
        <CalendarComponent
          viewDate={viewDate}
          onDateChange={handleViewChange}
          mapDays={({ date }) => {
            const ts = new Date(date.year, date.month.index, date.day).setHours(
              0,
              0,
              0,
              0
            )
            const isHighlighted = highlightedDays.has(ts)
            return {
              onClick: event => {
                handleAnchorEl(event.currentTarget, new Date(ts))
              },
              style: {
                backgroundColor: isHighlighted ? '#A2CC79' : 'unset',
                cursor: 'pointer'
              }
            }
          }}
        />
        <div className={classes.subtitle_wrapper}>
          <div className={classes.dot} />
          <p className={classes.subtitle}> Diários disponíveis</p>
        </div>
      </div>
      <Popover
        open={anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <div className={classes.popover}>
          <p>Selecione um dos diários gerados para a data selecionada</p>
          <div className={classes.reports_wrapper}>
            {reportsForDay.map(item => {
              const title = item.report.report_template.title
              return (
                <div
                  key={item.id}
                  onClick={() => handleClickReport(item)}
                  className={`${classes.subtitle_wrapper} selectable_option`}
                >
                  <div className={classes.dot} />
                  <p className={classes.subtitle}>{title}</p>
                </div>
              )
            })}
          </div>
        </div>
      </Popover>
    </div>
  )
}
